// function that returns true if value is email, false otherwise
const verifyEmail = value => {
  if (value === "") return true;
  // var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // var emailRex = /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/;
  var emailRex = /(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@[*[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+]*/;

  if (emailRex.test(value)) {
    return true;
  }
  return false;
};

// function that verifies if a string has a given length or not
const verifyLength = (value, length) => {
  if (value.length >= length.min && value.length <= length.max) {
    return true;
  }
  return false;
};

const verifyValidValue = (value, length) => {
  value = parseFloat(value.toString().replace(",", ""));
  let max = parseFloat(length.max.toString().replace(",", "")),
    min = parseFloat(length.min.toString().replace(",", ""));

  if (value >= min && value <= max) {
    return true;
  }
  return false;
};

const validate = (value, rules, error) => {
  let errorObj = []

  rules &&
    rules.forEach(rule => {
      switch (rule.type) {
        case "email":
          if (!verifyEmail(value)) {
            errorObj.push(error["valid"]);
          }
          break;
        case "required":
          if (typeof value === "string") {
            if (value.trim() === "") {
              errorObj.push(error["required"]);
            }
          } else {
            if (value === "") {
              errorObj.push(error["required"]);
            }
          }
          break;
        case "length":
          if (!verifyLength(value, rule.params)) {
            errorObj.push(error["range"]);
          }
          break;
        case "range":
          if (!verifyValidValue(value, rule.params)) {
            errorObj.push(error["range"]);
          }
          break;
        case "space":
          if (typeof value === "string") {
            if (value.trim().split(" ").length > 1) {
              errorObj.push(error["space"]);
            }
          }
          break;
        default:
          break;
      }
    });

  return errorObj;
};

export { validate };
